import NewCollectionPopup from './NewCollectionPopup';
import NewCollectionPopupContainer from './NewCollectionPopup.container';
export default NewCollectionPopupContainer(NewCollectionPopup);

//# sourceMappingURL=index.js.map